export const SALE_REPEATS =  [
    'Daily',
    'Weekly',
    'Monthly',
    'Yearly'
];

export const SALE_REPEAT_SAMPLES =  {
    'Daily': 'Write hours in format 1, 16, 23. If empty, will run every day at 00:00',
    'Weekly': 'Write weekdays in format Mon, Sat, Wed. If empty, will run on Monday 00:00 of each week',
    'Monthly': 'Write days 5, 16, 25. If empty. will run at 1 of each month',
    'Yearly': 'Write days in format Sep-2, Nov-20, Jun-14. If empty, will run at Jan-1 of each year'
};

export const PAYMENT_METHODS =  [
    'Bank card',
    'Cheque',
    'Cash',
    'E-transfer',
    'Direct deposit'
];

export const DEFAULT_PAYMENT_METHOD = PAYMENT_METHODS[0];

export const SALE_STATUS_READY_TO_DELIVER = 30
export const SALE_STATUS_COMPLETED = 99
export const SALE_STATUS_CANCELLED = -1
export const SALE_LOCKED_EDIT_STATUS_IDS = [SALE_STATUS_COMPLETED, SALE_STATUS_CANCELLED]

export const isSaleEditLocked = (status) => SALE_LOCKED_EDIT_STATUS_IDS.includes(Number(status))

export const isDeliveryOrderWithShippingDisplay = (status, sale) => {
    if (!sale) {
        return false
    }
    const isPickup = sale.pickup === true || sale.pickup === 1
    return !isPickup
}

export const shouldDisplaySaleStatusAsShipped = (status, sale) => {
    return isDeliveryOrderWithShippingDisplay(status, sale)
        && sale.has_remaining_to_ship === false
        && sale.has_any_shipped === true
}

export const shouldDisplaySaleStatusAsPartlyShipped = (status, sale) => {
    return isDeliveryOrderWithShippingDisplay(status, sale)
        && sale.has_remaining_to_ship === true
        && sale.has_any_shipped === true
}

export const shouldDisplayShippingStatusLabel = (status, sale) => {
    return shouldDisplaySaleStatusAsPartlyShipped(status, sale)
        || shouldDisplaySaleStatusAsShipped(status, sale)
}

export const shouldDisplaySaleStatusAsReturned = (status, sale) => {
    return sale?.has_any_returned === true
        && sale?.has_remaining_to_return === false
}

export const shouldDisplaySaleStatusAsPartlyReturned = (status, sale) => {
    return sale?.has_any_returned === true
        && sale?.has_remaining_to_return === true
}

export const shouldDisplayReturnStatusLabel = (status, sale) => {
    return shouldDisplaySaleStatusAsReturned(status, sale)
        || shouldDisplaySaleStatusAsPartlyReturned(status, sale)
}

export const getSaleStatusDisplay = (statusId, sale, statuses = SALE_STATUSES) => {
    const status = Object.values(statuses).find(s => s.id === Number(statusId)) ?? {
        id: -2,
        name: 'Unknown',
        class: 'yellow',
    }
    if (shouldDisplaySaleStatusAsReturned(statusId, sale)) {
        return { ...status, name: 'Returned' }
    }
    if (shouldDisplaySaleStatusAsPartlyReturned(statusId, sale)) {
        return { ...status, name: 'Partly Returned' }
    }
    if (shouldDisplaySaleStatusAsShipped(statusId, sale)) {
        return { ...status, name: 'Shipped' }
    }
    if (shouldDisplaySaleStatusAsPartlyShipped(statusId, sale)) {
        return { ...status, name: 'Partly Shipped' }
    }
    return status
}

export const SALE_STATUSES = [
    {
        id: 0,
        name: "New",
        class: "light-dark",
    },
    {
        id: 10,
        name: "Accepted",
        class: "light-primary",
    },
    {
        id: 20,
        name: "In Process",
        class: "yellow",
    },
    {
        id: 30,
        name: "Ready to deliver",
        class: "light-success",
    },
    {
        id: 99,
        name: "Completed",
        class: "success",
    },
    {
        id: -1,
        name: "Cancelled",
        class: "danger",
    }
];
/*
export const SALE_STATUSES =  {
    0: {
        id: 0,
        name: "New",
        class: "light-dark",
    },
    1: {
        id: 1,
        name: "Accepted",
        class: "yellow",
    },
    2: {
        id: 2,
        name: "In Process", // Working on it
        class: "light-primary",
    },
    3: {
        id: 3,
        name: "Completed",
        class: "light-success",
    },
    4: {
        id: 4,
        name: "Delivered",
        class: "light-success",
    },
    5: {
        id: 5,
        name: "Cancelled",
        class: "danger",
    },
}*/

/*
shit from backend
const PAYMENT_STATUS_DEPOSIT_NEEDED = 0;
const PAYMENT_STATUS_DEPOSIT_PAID = 1;
const PAYMENT_STATUS_PARTLY_PAID = 2;
const PAYMENT_STATUS_FULLY_PAID = 3;
const PAYMENT_STATUS_OVERPAID = 4;
*/
export const SALE_PAYMENT_STATUSES =  {
    0: {
        id: 0,
        name: "Not paid",
        class: "light-danger",
    },
    1: {
        id: 1,
        name: "Deposit Paid",
        class: "light-primary",
    },
    2: {
        id: 2,
        name: "Partially Paid",
        class: "light-warning",
    },
    3: {
        id: 3,
        name: "Fully Paid",
        class: "success",
    },
    4: {
        id: 4,
        name: "Overpaid",
        class: "light-success",
    },
    5: {
        id: 5,
        name: "Fully Refunded",
        class: "light-warning",
    },
};

export const LANDING_HERO_SLIDES = [
    {
        title: 'We’ve created a powerful CRM for small and medium-sized businesses. We’re constantly improving it, with new features released every week.',
        image: 'hero-1.png',
        position: 'bottom-right',
        textAlign: 'right',
        fontColor: '#000000',
        backgroundColor: '#ffffff',
    },
    {
        title: 'Scan barcodes to find products, update stock levels, and create orders',
        image: 'hero-2.png',
        position: 'top-right',
        textAlign: 'right',
        fontColor: '#000000',
        backgroundColor: '#ffffff',
    },
    {
        title: '100% mobile-friendly interface: work from anywhere on your phone',
        image: 'hero-11.png',
        position: 'bottom-left',
        textAlign: 'right',
        fontColor: '#000000',
        backgroundColor: '#ffffff',
    },
    {
        title: 'Manage your orders, shipments and returns, set statuses, update the progress, and more...',
        image: 'hero-3.png',
        position: 'bottom-left',
        textAlign: 'left',
        fontColor: '#FFFFFF',
        backgroundColor: '#FFC100',
    },
    {
        title: 'Create Products, manage stock availability. Define multiple stock locations and keep them accurate every day',
        image: 'hero-4.png',
        position: 'top-right',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#A046DF',
    },
    {
        title: 'Manage your customers, their addresses, contacts and order history in one place',
        image: 'hero-5.png',
        position: 'bottom-right',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#00A0FF',
    },
    {
        title: 'Create staff with custom permissions to manage orders',
        image: 'hero-6.png',
        position: 'bottom-left',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#42B549',
    },
    {
        title: 'Detailed statistics on orders, returns, refunds, and totals by date',
        image: 'hero-7.png',
        position: 'top-right',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#0257A2',
    },
    {
        title: 'Track staff productivity and busyness with clear statistics',
        image: 'hero-8.png',
        position: 'bottom-left',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#C83D33',
    },
    {
        title: 'Define the services your business is providing, set prices and create orders',
        image: 'hero-9.png',
        position: 'top-right',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#FFA600',
    },
    {
        title: 'Create orders with products and services together when you need both',
        image: 'hero-10.png',
        position: 'bottom-right',
        textAlign: 'right',
        fontColor: '#FFFFFF',
        backgroundColor: '#FE393C',
    },
    
]

/** Dwell time on the first hero slide before switching to slide 2 (ms). */
export const LANDING_HERO_FIRST_SLIDE_INTERVAL_MS = 6000

/** Dwell time for subsequent hero slides (ms). */
export const LANDING_HERO_SLIDE_INTERVAL_MS = 3000

/** Max characters per hero caption line (word-wrapped). */
export const LANDING_HERO_TITLE_MAX_CHARS_PER_LINE = 40

/** Bootstrap-Vue datepicker label format: "Oct 7, 2026" (no weekday). */
export const FORM_DATEPICKER_FORMAT_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
}

export default {

    SALE_STATUS_READY_TO_DELIVER,
    SALE_STATUS_COMPLETED,
    SALE_STATUS_CANCELLED,
    SALE_LOCKED_EDIT_STATUS_IDS,
    isSaleEditLocked,
    shouldDisplaySaleStatusAsShipped,
    shouldDisplaySaleStatusAsPartlyShipped,
    shouldDisplayShippingStatusLabel,
    shouldDisplaySaleStatusAsReturned,
    shouldDisplaySaleStatusAsPartlyReturned,
    shouldDisplayReturnStatusLabel,
    getSaleStatusDisplay,
    SALE_STATUSES,
    SALE_PAYMENT_STATUSES,
    SALE_REPEATS,
    SALE_REPEAT_SAMPLES,
    PAYMENT_METHODS,
    DEFAULT_PAYMENT_METHOD,
    LANDING_HERO_SLIDES,
    LANDING_HERO_FIRST_SLIDE_INTERVAL_MS,
    LANDING_HERO_SLIDE_INTERVAL_MS,
    LANDING_HERO_TITLE_MAX_CHARS_PER_LINE,
    FORM_DATEPICKER_FORMAT_OPTIONS,
}